// extracted by css-extract-rspack-plugin
export default {"button":"ImageWidget_button_GXZOc","icon":"ImageWidget_icon_RPZtb","wrapper":"ImageWidget_wrapper_LyZjR","inFocus":"ImageWidget_inFocus__KSDr"};